'use strict';
angular.module('draftlistModule', []).controller('draftlistCtrl', draftlistCtrl);
draftlistCtrl.$inject = [
    '$scope',
    '$modalInstance',
    '$compile',
    '$validation',
    'draftListParams',
    'trsHttpService',
    'trsspliceString',
    'modalDialog',
];

/**
 * [draftlistCtrl 发稿单控制器]
 *
 * @param   {[type]}  $scope           [$scope description]
 * @param   {[type]}  $modalInstance   [$modalInstance description]
 * @param   {[type]}  $compile         [$compile description]
 * @param   {[type]}  $validation      [$validation description]
 * @param   {[type]}  draftListParams  [draftListParams description]
 * @param   {[type]}  trsHttpService   [trsHttpService description]
 * @param   {[type]}  trsspliceString  [trsspliceString description]
 * @param   {[type]}  modalDialog      [modalDialog description]
 *
 * @return  {[type]}                   [return description]
 */
function draftlistCtrl($scope, $modalInstance, $compile, $validation, draftListParams, trsHttpService, trsspliceString, modalDialog) {
    init();
    $scope.confirm = function() {
        $validation.validate($scope.draftForm.authorForm).success(function() {
            var fgdParams = draftListParams.params;
            //处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined($scope.list.fgd_authinfo[0]) &&
                (!angular.isDefined($scope.list.fgd_authinfo[0].USERNAME) || $scope.list.fgd_authinfo[0].USERNAME === '')
            ) {
                $scope.list.fgd_authinfo = [];
            }
            //处理发稿单作者信息空数据提交问题
            fgdParams.fgd_editinfo = JSON.stringify(angular.copy($scope.list.fgd_editinfo));
            fgdParams.fgd_authinfo = JSON.stringify(angular.copy($scope.list.fgd_authinfo));
            if (!draftListParams.editFGDParams) {
                fgdParams.chnlDocIds = trsspliceString.spliceString(draftListParams.array, 'CHNLDOCID', ',');
                fgdParams.MetaDataIds = trsspliceString.spliceString(draftListParams.array, 'METADATAID', ',');
            }
            fgdParams.DocGenre = JSON.stringify($scope.list.DocGenre);
            fgdParams.ISNOPAYMENT = $scope.list.ISNOPAYMENT;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), fgdParams, 'post').then(function(data) {
                modalDialog.multiReportsAlert(data, function() {
                    $modalInstance.close('success');
                });
                // modalDialog.alertType("", "保存成功", "success", false, function() {
                //     $modalInstance.close("success");
                // });
            });
        });
    };
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

    /**
     * [init 初始化]
     *
     * @return  {[type]}  [return description]
     */
    function init() {
        trsHttpService.httpServer('./editingCenter/properties/metadataEnum.json', '', 'get').then(function(data) {
            //初始化页面参数
            $scope.DOCGENRE = data.DocGenre;
            if (draftListParams.array.length != 1 || draftListParams.array[0].METADATAID == 0) {
                $scope.list = {
                    DocGenre: angular.copy($scope.DOCGENRE[0]),
                    fgd_editinfo: [],
                    fgd_authinfo: [],
                    ISNOPAYMENT: '1',
                };
                loadDirective();
            } else if (draftListParams.editFGDParams) {
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), draftListParams.editFGDParams, 'post').then(function(fgd_data) {
                    $scope.list = {
                        DocGenre: fgd_data.DOCGENRE,
                        fgd_editinfo: fgd_data.FGD_EDITINFO,
                        fgd_authinfo: fgd_data.FGD_AUTHINFO,
                        ISNOPAYMENT: fgd_data.ISNOPAYMENT,
                    };
                    loadDirective();
                });
            } else {
                $scope.metaDataId = draftListParams.array[0].METADATAID;
                var params = {
                    serviceid: 'mlf_appfgd',
                    methodname: 'queryFgdByMetaDataId',
                    MetaDataId: draftListParams.array[0].METADATAID,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(fgd_data) {
                    $scope.list = {
                        DocGenre: fgd_data.DOCGENRE,
                        fgd_editinfo: fgd_data.FGD_EDITINFO,
                        fgd_authinfo: fgd_data.FGD_AUTHINFO,
                        ISNOPAYMENT: fgd_data.ISNOPAYMENT,
                    };
                    loadDirective();
                });
            }
        });

        /**
         * [loadDirective 动态加载指令]
         *
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{metaDataId}}" editor-json="list.fgd_editinfo"></editor-dir>' +
                '<editor-auth-dir author="list.fgd_authinfo"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $($(angular.element(document)).find('editor')).append(draftList);
        }
    }
}
